import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { LabelState } from '../../types'

export const updateLabelAction = createAsyncAction(
  '@chat/UPDATE_LABEL_REQUEST',
  '@chat/UPDATE_LABEL_SUCCESS',
  '@chat/UPDATE_LABEL_FAILURE'
)<Request, Success, Failure>()

const request = (state: LabelState, action: ActionType<typeof updateLabelAction.request>): LabelState => ({
  ...state,
  isLoadingUpdateLabel: true
})

const success = (state: LabelState, action: ActionType<typeof updateLabelAction.success>): LabelState => {
  const updatedLabel = action.payload
  const labels = state.labels
  const labelIndex = labels.findIndex(label => label.id === updatedLabel.id)
  if (!(labelIndex === -1)) {
    delete updatedLabel.id
    labels[labelIndex] = { ...labels[labelIndex], ...updatedLabel }
  }

  return {
    ...state,
    labels,
    isLoadingUpdateLabel: false,
    isSuccessOnUpdateLabel: true
  }
}
const failure = (state: LabelState, action: ActionType<typeof updateLabelAction.failure>): LabelState => ({
  ...state,
  isLoadingUpdateLabel: false,
  isErrorOnUpdateLabel: true
})

export const updateLabelHandle = { asyncAction: updateLabelAction, request, success, failure }
